export default __webpack_public_path__ + "static/media/Barret-M82a1-Remote-11.379bfa50.jpg";